import React, { memo } from 'react'
import { View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { BtInput } from '@linqpal/components/src/ui'
import { SearchLoop } from '../../../../../assets/icons'

import { styles } from './styles'

type SearchProps = {
  value: string
  onChange: any
  setResetPaginationToggle: any
  resetPaginationToggle: boolean
}
export const SearchField = memo(
  ({
    value,
    onChange,
    setResetPaginationToggle,
    resetPaginationToggle,
  }: SearchProps) => {
    const { t } = useTranslation('global')
    const handleClear = () => {
      if (value) {
        setResetPaginationToggle(!resetPaginationToggle)
        onChange('')
      }
    }
    return (
      <View style={{ width: '100%', alignItems: 'center' }}>
        <BtInput
          placeholder={t('Projects.searchProjectName' as any)}
          style={styles.input}
          containerStyle={{
            borderWidth: 1,
            borderColor: '#E4E9F2',
            height: 40,
          }}
          onChangeText={onChange}
          value={value}
          onClear={handleClear}
          testID="projects-search-input"
          rightComponent={<SearchLoop />}
        />
      </View>
    )
  },
)
